import { MONTH_OPTIONS } from "@/_old/constants/dashboard-date-filter";
import { BOOKING_TYPE } from "@/_old/features/dashboard-charts";
import { CityName } from "@/_old/features/filters/entities/city.types";
import { getLastDayOfMonth } from "@/_old/utils/date";
import { createContext, FunctionComponent, useContext, useState } from "react";
import { Group } from "../../entities/group.types";
import { getDateLimits } from "../../utils/date-limits";
import {
  DateLimits,
  FiltersContextProps,
  FiltersProviderProps,
} from "./filters.types";
import { Space } from "../../entities/space.types";
import { Member } from "../../entities/member.types";
import { MultiselectDropdownOptions } from "@/_old/components/multiselect-dropdown/multiselect-dropdown.types";

const FiltersContext = createContext<FiltersContextProps>(
  {} as FiltersContextProps,
);

export const FiltersProvider: FunctionComponent<FiltersProviderProps> = ({
  children,
}) => {
  const [dateLimits, setDateLimits] = useState<DateLimits>(
    getDateLimits(getLastDayOfMonth(), 1),
  );
  const [city, setCity] = useState<CityName | null>();
  const [groupId, setGroupId] = useState<Group["id"] | null>();
  const [groupName, setGroupName] = useState<Group["name"] | null>();
  const [companyId, setCompanyId] = useState<Group["companyId"] | null>();
  const [bookingType, setBookingType] = useState<
    BOOKING_TYPE | MultiselectDropdownOptions[] | null
  >();
  const [currency, setCurrency] = useState(true);
  const [activeCurrency, setActiveCurrency] = useState("money");
  const [spaces, setSpaces] = useState<Space[] | null>(null);
  const [users, setUsers] = useState<Member[] | null>(null);
  const [status, setStatus] = useState<MultiselectDropdownOptions[] | null>(
    null,
  );
  const [monthDropdownValue, setMonthDropdownValue] = useState(
    MONTH_OPTIONS.CURRENT_MONTH.label,
  );
  const [cities, setCities] = useState<MultiselectDropdownOptions[] | null>(
    null,
  );
  const [neighborhoods, setNeighborhoods] = useState<
    MultiselectDropdownOptions[] | null
  >(null);

  const handleChangeCurrency = (value: string) => {
    setActiveCurrency(value);
  };

  const handleChangeTypeCurrency = () => {
    setCurrency(!currency);
  };

  return (
    <FiltersContext.Provider
      value={{
        dateLimits,
        setDateLimits,
        city,
        setCity,
        groupId,
        setGroupId,
        groupName,
        setGroupName,
        bookingType,
        setBookingType,
        currency,
        handleChangeTypeCurrency,
        activeCurrency,
        handleChangeCurrency,
        monthDropdownValue,
        setMonthDropdownValue,
        spaces,
        setSpaces,
        status,
        setStatus,
        cities,
        setCities,
        neighborhoods,
        setNeighborhoods,
        users,
        setUsers,
        companyId,
        setCompanyId,
      }}
    >
      {children}
    </FiltersContext.Provider>
  );
};

export const useFilters = () => useContext(FiltersContext);
